import * as React from 'react';
import 'swiper/swiper-bundle.css';
import Loader from './loader';
import { Routes, Route, Navigate } from 'react-router-dom'
import RouteLoader from './RouteLoader';
import { ISNEWROUTE } from '@src/utils/constant';

const ROUTES = require('./runtime').default;
require('../styles/global.css');
require('../styles/nprogress.css');
require('../styles/table.less');

const isNewRouter = localStorage.getItem(ISNEWROUTE) || 'false';

const oldRouteList = [
  "/:type/wecode",
  "/wecode/:type/guide",
  "/wecode/:type/list",
  "/:type/appdetail/*",
  "/:type/createwecode",
  "/wecode/create-robot",
  "/wecode/robot-info",
];

const newRouteList = [
  '/:type/wecode-v2',
  '/:type/appdetailV2/*',
];

const renderRoute = (props) => {
  const { path, ...restProps } = props;
  const renderRouteNode = (_path) => {
    return (
      <Route {...restProps} path={_path} />
    )
  }
  if (typeof path === 'string') {
    return renderRouteNode(path);
  } else if (Array.isArray(path)) {
    return path.map(item => renderRouteNode(item))
  }
  return null;
}

const RenderRoute = routerPath => {
  const allRouterlist = [];
  const handleRouterList = (routes) => {
    if (!routes) {
      return;
    }
    routes.keys().map(key => {
      const route = routes(key).default;
      const Cmp = Loader(route);
      let res = renderRoute({
        key,
        exact: false,
        ...route,
        element: (
          <RouteLoader
            path={route.path}
            leftSlider={route.leftSlider}
            element={Cmp}
            key={key}
          />
        )
      })
      if (!res) return;
      if (Array.isArray(res)) {
        allRouterlist.push(...res)
      } else {
        allRouterlist.push(res)
      }
    })
  }
  routerPath.map((router) => {
    handleRouterList(router)
  });
  if (isNewRouter === 'true') {
    allRouterlist?.splice(0, 0, ...renderOldRoute());
  } else {
    allRouterlist?.splice(0, 0, ...renderNewRoute());
  }
  return allRouterlist;
};

const renderOldRoute = () => {
  return oldRouteList.map(path => {
    return <Route path={path} element={<Navigate to="/0/wecode-v2" />} />
  })
};

const renderNewRoute = () => {
  return newRouteList.map(path => {
    return <Route path={path} element={<Navigate to="/wecode/guide/guide" />} />
  })
};
export default class extends React.Component {
  render() {
    return (
      <Routes>
        {RenderRoute(ROUTES)}
        {(process.env.REACT_APP_WELINK_ENV === 'redBlue') ? (
          <Route path="*" element={<Navigate to="/appList" />} />
        ) : (
          <Route path="*" element={<Navigate to="/home" />} />
        )}
      </Routes>
    );
  }
}
